import React from 'react';

const COLORS = {
  '10-Day IL': { bg: 'bg-[#c4333e]', text: 'text-white', border: 'border-[#c4333e]' },
  '15-Day IL': { bg: 'bg-[#c4333e]', text: 'text-white', border: 'border-[#c4333e]' },
  '60-Day IL': { bg: 'bg-[#7a1a22]', text: 'text-white', border: 'border-[#7a1a22]' },
  'Day-to-Day': { bg: 'bg-[#b8860b]', text: 'text-white', border: 'border-[#b8860b]' },
  default: { bg: 'bg-[#386646]', text: 'text-[#d8ceb3]', border: 'border-[#658d71]' },
};

const InjuryBadge = ({ status }) => {
  const scheme = COLORS[status] || COLORS.default;
  return (
    <span className={`text-[8px] font-black uppercase tracking-widest px-1.5 py-0.5 border ${scheme.bg} ${scheme.text} ${scheme.border} shrink-0`}>
      {status || 'IL'}
    </span>
  );
};

export default InjuryBadge;